import styled from 'styled-components';
import { Label, Container } from './Styles';

const WishListContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: ${(props) => props.theme.fonts.sansSerif};
  font-weight: 400;
  width: 22px;
  height: 22px;
  margin: 5px 0;
  cursor: pointer;
  border-radius: 22px;
  border: 2px solid var(--darkGrey);
  background: ${(props) => (!props.$isStared ? 'transparent' : '#fff')};

  svg {
    width: 18px;
    height: auto;
    path {
      fill: var(--darkGrey);
    }
  }
`;

const WishListBtn = ({ clickEvent, isInWishList }) => (
  <Container onClick={() => clickEvent()}>
    <WishListContainer>
      <svg
        className="wishlist"
        xmlns="http://www.w3.org/2000/svg"
        width="800"
        height="800"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          fill="#1C274C"
          fillRule="evenodd"
          d="M2.25 6A.75.75 0 0 1 3 5.25h17a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 6Zm0 5a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Zm0 5a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z"
          clipRule="evenodd"
        />
        <path
          fill="#1C274C"
          d="M13 11.715c0 1.752 2.163 3.615 3.49 4.593.454.335.681.502 1.01.502.329 0 .556-.167 1.01-.502 1.327-.978 3.49-2.84 3.49-4.593 0-2.677-2.475-3.677-4.5-1.609-2.025-2.068-4.5-1.068-4.5 1.609Z"
        />
      </svg>
    </WishListContainer>
    <Label>{isInWishList ? 'Un-Wish' : 'Wishlist'}</Label>
  </Container>
);

export default WishListBtn;
